export const TABLE_HEADINGS = [
  { lg: 4, title: 'Store Name' },
  { lg: 4, title: 'Store Link' },
  { lg: 4, title: 'Plan' }
];
